export default {
  listCategories: async () => {
    return ['50/50', 'Raffle', 'Sweepstakes', 'Promo Raffle'];
  }
};
